import React from 'react';
import { Stack } from '../../components/Stack/Stack';
import { LineAreaChart } from './LineAreaChart/LineAreaChart';

import { formatDate } from '../../util/formatters';

export const mock = [
  {
    quantity: 0,
    total: 0,
    date: '2022-08-08',
  },
  {
    quantity: 100,
    total: 560,
    date: '2022-08-09',
  },
  {
    quantity: 20,
    total: 580,
    date: '2022-08-10',
  },
  {
    quantity: 10,
    total: 590,
    date: '2022-08-11',
  },
  {
    quantity: 4332,
    total: 590,
    date: '2022-08-12',
  },
  {
    quantity: 0,
    total: 590,
    date: '2022-08-13',
  },
  {
    quantity: 20,
    total: 610,
    date: '2022-08-14',
  },
  {
    quantity: 10,
    total: 620,
    date: '2022-08-15',
  },
  {
    quantity: 0,
    total: 620,
    date: '2022-08-16',
  },
  {
    quantity: 0,
    total: 620,
    date: '2022-08-17',
  },
  {
    quantity: 50,
    total: 670,
    date: '2022-08-18',
  },
  {
    quantity: 30,
    total: 700,
    date: '2022-08-19',
  },
  {
    quantity: 500,
    total: 1300,
    date: '2022-08-20',
  },
  {
    quantity: 20,
    total: 1320,
    date: '2022-08-21',
  },
  {
    quantity: 108,
    total: 1500,
    date: '2022-08-22',
  },
  {
    quantity: 500,
    total: 2000,
    date: '2022-08-23',
  },
  {
    quantity: 500,
    total: 2500,
    date: '2022-08-24',
  },
  {
    quantity: 500,
    total: 3000,
    date: '2022-08-25',
  },
  {
    quantity: 10,
    total: 3010,
    date: '2022-08-25',
  },
  {
    quantity: 1000,
    total: 4010,
    date: '2022-08-25',
  },
  {
    quantity: 500,
    total: 4510,
    date: '2022-08-25',
  },
  {
    quantity: 1000,
    total: 5510,
    date: '2022-08-25',
  },
  {
    quantity: 500,
    total: 6010,
    date: '2022-08-25',
  },
  {
    quantity: 1000,
    total: 7010,
    date: '2022-08-25',
  },
  {
    quantity: 1000,
    total: 8010,
    date: '2022-08-25',
  },
  {
    quantity: 100,
    total: 23500,
    date: '2022-08-25',
  },
];

const convertToLineAreaValues = (data: typeof mock): React.ComponentProps<typeof LineAreaChart>['dataset'] => {
  return data.map((d) => ({
    name: formatDate(d.date) || 'N/A',
    line: d.total,
    area: d.quantity,
  }));
};

export function LineAreaChartExample(): JSX.Element {
  return (
    <Stack size="lg">
      <LineAreaChart dataset={convertToLineAreaValues(mock)} lineLabel="Total Sales" areaLabel="Daily Sales" />
    </Stack>
  );
}
